import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges,
         SimpleChange
       } from '@angular/core';

import { BulkAmountConfig, PriceConfig } from 'app/product-designer-config';
import { Price } from 'core/price/price';
import { PriceCalculationService } from 'core/price/price-calculation.service';
import { ProductService } from 'core/product/product.service';
import { Utils } from 'core/utils';
import { FeatureConfig, FeatureGroupConfig, ProductConfig
       } from '../product-designer-config';

@Component({
    selector: 'feature-selection',
    templateUrl: './feature-selection.component.html',
    styleUrls: ['./feature-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FeatureSelectionComponent implements OnChanges
{
  public featureGroup: FeatureGroupConfig;
  public price: Price;
  public product: ProductConfig;
  public features: Array<FeatureConfig>;
  public selectedFeature: FeatureConfig;
  public promotionSignUrl: string = Utils.url(
      './assets/img/promotion-sign.svg');

  public trackById: (index: number, item: any) => any = Utils.trackById;
  public getCurrentPriceConfig: (priceConfig: PriceConfig, quantity: number) =>
      PriceConfig | BulkAmountConfig = Utils.getCurrentPriceConfig;

  @Input('featureGroupId') public featureGroupId: string;

  constructor(
      public priceCalculationService: PriceCalculationService,
      @Inject(ProductService) productService: ProductService)
  {
    this.product = productService.getCurrentProduct();
  }

  private calculateCurrentFeatures(): void
  {
    this.features = Object.keys(this.featureGroup.features).map(
        key => this.featureGroup.features[key]).map(
            feature => { return feature; });
  }

  public refreshSelectedFeature(): void
  {
    let selectedFeatureId = this.featureGroup.selectedFeature;
    if (selectedFeatureId) {
      this.selectedFeature = this.featureGroup.features[selectedFeatureId];
    }
    else {
      let firstFeatureId = Object.keys(this.featureGroup.features)[0];
      this.selectedFeature = this.featureGroup.features[firstFeatureId];
    }
  }

  public ngOnChanges(changes: {[propKey: string]: SimpleChange}): void
  {
    if (changes['featureGroupId']) {
      let featureGroupId = changes['featureGroupId'].currentValue;
      this.featureGroup = this.product.featureGroups[featureGroupId];
    }
    this.calculateCurrentFeatures();
    this.refreshSelectedFeature();
  }

  public setSelectedFeature(selection: string): void
  {
    this.featureGroup.selectedFeature = selection;
    this.priceCalculationService.calculateTotalPrice();
    this.refreshSelectedFeature();
  }
}
